export default __webpack_public_path__ + "static/media/svg-2.6c5baeba.svg";